//production
export const api_domain = 'https://api.thaibikeparts.com/'
//dev
// export const api_domain = 'http://127.0.0.1:8000/'
// TEST API
// export const api_domain = 'https://apihellocst.ksta.co/'